import ServicePageTemplate from '../services/ServicePageTemplate';
import { seoPageData } from '../../mocks/seoPages';
const DuctlessSystemsPage = () => <ServicePageTemplate data={seoPageData['ductless-systems']} />;
export default DuctlessSystemsPage;
